import { createGlobalStyle } from 'styled-components';
import iconArrowDown from './images/icon-arrow-down.svg';
/*
Please remove the component variables you dont need

TIPS:
Generate color shades here: https://superdevresources.com/tools/color-shades#5F11E8
*/
export const Theme = createGlobalStyle`
  :root {
    /* Colors */
    --c-black: rgb(24, 24, 24);                     --c-black--text: rgb(255, 255, 255);
    --c-white: rgb(255, 255, 255);                  --c-white--text: var(--c-black);
    --c-white--hover: rgb(235, 235, 235);           --c-white--hover--text: var(--c-black);

    /* Colors - primary */
    --c-primary--50:  rgb(239, 231, 253);           --c-primary--50--text:  var(--c-black);
    --c-primary--100: rgb(208, 184, 250);           --c-primary--100--text: var(--c-black);
    --c-primary--200: rgb(176, 136, 246);           --c-primary--200--text: var(--c-black);
    --c-primary--300: rgb(145, 89, 243);            --c-primary--300--text: var(--c-white);
    --c-primary--400: rgb(113, 41, 239);            --c-primary--400--text: var(--c-white);
    --c-primary--500: rgb(88, 16, 214);             --c-primary--500--text: var(--c-white);
    --c-primary--600: rgb(68, 12, 166);             --c-primary--600--text: var(--c-white);
    --c-primary--700: rgb(49, 9, 119);              --c-primary--700--text: var(--c-white);
    --c-primary--800: rgb(29, 5, 71);               --c-primary--800--text: var(--c-white);
    --c-primary--900: rgb(10, 2, 24);               --c-primary--900--text: var(--c-white);

    --c-primary--light: var(--c-primary--200);      --c-primary--light--text: var(--c-primary--200--text);
    --c-primary--dark: var(--c-primary--600);       --c-primary--dark--text: var(--c-primary--600--text);
    --c-primary--hover: var(--c-primary--600);      --c-primary--hover--text: var(--c-primary--600--text);
    --c-primary--opacity: rgba(88, 16, 214, 0.4);   --c-primary--opacity--text: var(--c-white);
    --c-primary: var(--c-primary--500);             --c-primary--text: var(--c-primary--500--text);

    /* Colors - secondary */
    /* --c-secondary--50:  rgb(255, 234, 229);         --c-secondary--50--text:  var(--c-black);
    --c-secondary--100: rgb(255, 192, 179);         --c-secondary--100--text: var(--c-black);
    --c-secondary--200: rgb(255, 150, 128);         --c-secondary--200--text: var(--c-black);
    --c-secondary--300: rgb(255, 107, 77);          --c-secondary--300--text: var(--c-black);
    --c-secondary--400: rgb(255, 65, 26);           --c-secondary--400--text: var(--c-white);
    --c-secondary--500: rgb(230, 40, 0);            --c-secondary--500--text: var(--c-white);
    --c-secondary--600: rgb(179, 31, 0);            --c-secondary--600--text: var(--c-white);
    --c-secondary--700: rgb(128, 22, 0);            --c-secondary--700--text: var(--c-white);
    --c-secondary--800: rgb(77, 13, 0);             --c-secondary--800--text: var(--c-white);
    --c-secondary--900: rgb(26, 4, 0);              --c-secondary--900--text: var(--c-white);

    --c-secondary--light: var(--c-secondary--50);   --c-secondary--light--text: var(--c-secondary--50--text);
    --c-secondary--dark: var(--c-secondary--200);   --c-secondary--dark--text: var(--c-secondary--200--text);
    --c-secondary--opacity: rgba(255, 150, 128, 0.4); --c-secondary--opacity--text: var(--c-dark); */
    --c-secondary: #666666;                         --c-secondary--text: #ffffff;

    /* Colors - accent */
    --c-accent--50:  rgb(238, 250, 235);            --c-accent--50--text:  var(--c-black);
    --c-accent--100: rgb(205, 240, 194);            --c-accent--100--text: var(--c-black);
    --c-accent--200: rgb(171, 230, 153);            --c-accent--200--text: var(--c-black);
    --c-accent--300: rgb(138, 219, 112);            --c-accent--300--text: var(--c-black);
    --c-accent--400: rgb(104, 209, 71);             --c-accent--400--text: var(--c-white);
    --c-accent--500: rgb(79, 184, 46);              --c-accent--500--text: var(--c-white);
    --c-accent--600: rgb(61, 143, 36);              --c-accent--600--text: var(--c-white);
    --c-accent--700: rgb(44, 102, 25);              --c-accent--700--text: var(--c-white);
    --c-accent--800: rgb(26, 61, 15);               --c-accent--800--text: var(--c-white);
    --c-accent--900: rgb(9, 20, 5);                 --c-accent--900--text: var(--c-white);

    --c-accent--light: var(--c-accent--300);        --c-accent--light--text: var(--c-accent--300--text);
    --c-accent--dark: var(--c-accent--300);         --c-accent--dark--text: var(--c-accent--300--text);
    --c-accent--opacity: rgba(104, 209, 71, 0.4);   --c-accent--opacity--text: var(--c-black);
    --c-accent: var(--c-accent--400);               --c-accent--text: var(--c-accent--400--text);


    /* Colors - neutral */
    --c-neutral--50:  rgb(240, 240, 240);           --c-neutral--50--text:  var(--c-black);
    --c-neutral--100: rgb(220, 220, 220);           --c-neutral--100--text: var(--c-black);
    --c-neutral--200: rgb(200, 200, 200);           --c-neutral--200--text: var(--c-black);
    --c-neutral--300: rgb(180, 180, 180);           --c-neutral--300--text: var(--c-black);
    --c-neutral--400: rgb(150, 150, 150);           --c-neutral--400--text: var(--c-black);
    --c-neutral--500: rgb(128, 128, 128);           --c-neutral--500--text: var(--c-white);
    --c-neutral--600: rgb(100, 100, 100);           --c-neutral--600--text: var(--c-white);
    --c-neutral--700: rgb(60, 60, 60);              --c-neutral--700--text: var(--c-white);
    --c-neutral--800: rgb(20, 20, 20);              --c-neutral--800--text: var(--c-white);
    --c-neutral--900: rgb(0, 0, 0);                 --c-neutral--900--text: var(--c-white);

    --c-neutral--light: var(--c-neutral--300);      --c-neutral--light--text: var(--c-neutral--300--text);
    --c-neutral--dark: var(--c-neutral--500);       --c-neutral--dark--text: var(--c-neutral--500--text);
    --c-neutral--opacity: rgba(88, 16, 214, 0.4);   --c-neutral--opacity--text: var(--c-black);
    --c-neutral: var(--c-neutral--400);             --c-neutral--text: var(--c-neutral--400--text);

    --c-bg: var(--c-black);                         --c-bg--text: var(--c-black--text);

    --c-body: var(--c-black--text);
    --c-disabled: silver;

    /* Semantic colors */
    --c-danger: rgb(238, 40, 95);                    --c-danger--text: var(--c-white);
    --c-warning: rgb(255, 222, 127);                 --c-warning--text: var(--c-black);
    --c-info: rgb(123, 215, 94);                     --c-info--text: var(--c-black);

    /* Spacing */
    --s-tiny: 10px;
    --s-small: 20px;
    --s-medium: 30px;
    --s-large: 60px;
    --s-huge: 120px;

    /* Borders */
    --b-width: 1px;
    --b-primary: var(--b-width) solid var(--c-primary);
    --b-radius: 4px;

    /* Fonts */
    /* Tips: Use https://meowni.ca/font-style-matcher/ to find a good fallback font (monospace) */
    --f-weight-normal: 400;
    --f-weight-bold: 700;
    --f-primary: 'Roboto Mono', monospace;
    --f-body: var(--f-weight-normal) 1.0605rem 'Roboto Mono', monospace;
    --f-header: 'Spectral SC', Georgia, serif;
    --f-body-big: 1.5rem 'Roboto Mono', monospace;
    --f-body-small: 0.825rem 'Roboto Mono', monospace;
    --f-special-transform: uppercase; /* for example buttons */
    --f-special-spacing: 0.08em; /* for example buttons */
    --f-spacing: 0;
    --f-height: 1.5826;

    /* Time / transition / easing */
    --t-base: 0.3s;
    --t-fast: 0.15s;
    --t-slow: 0.6s;
    --e-out: cubic-bezier(.2,.5,.3,1);
    --e-in: cubic-bezier(.6,0,.8,.5);

    /* Icons */
    --icon-arrow-down: url(${iconArrowDown});

    /* Shadows */
    --s-2dp:  rgba(20, 19, 42, 0.1) 0px 2px 10px -1px, rgba(20, 19, 42, 0.05) 0px 1px 1px 0px;
    --s-6dp:  rgba(20, 19, 42, 0.2) 0px 4px 15px -3px, rgba(20, 19, 42, 0.10) 0px 3px 2px -1px;
    --s-12dp: rgba(20, 19, 42, 0.3) 0px 8px 20px -5px, rgba(20, 19, 42, 0.15) 0px 4px 3px -1px;
    --s-24dp: rgba(20, 19, 42, 0.6) 0px 14px 30px -7px, rgba(20, 19, 42, 0.25) 0px 6px 4px -2px;

    /* Component: BorderButtons */
    --borderbutton-primary: url('./components/images/buttons/button_orange.png');
    --borderbutton-secondary: url('./components/images/buttons/button_gray.png');
    --borderbutton-primary-active: url('./components/images/buttons/button_orange_clicked.png');
    --borderbutton-secondary-active: url('./components/images/buttons/button_gray_clicked.png');

  }

  p {
    font-size: 18px;

    @media (min-width: 800px) {
      font: var(--f-body);
    }
  }

  h1, h2, h4, h5, h6 {
    font-family: var(--f-header);
    font-weight: var(--f-weight-normal);
  }

  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 40px;
    line-height: 46px;
  }

  h3 {
    font: var(--f-body);
  }

  h4 {
    font-size: 24px;
  }


  h5 {
    font-size: 14px;
  }

  hr {
    border: none;
    height: 1px;
    background: var(--c-black);
    margin: var(--s-small) 0 var(--s-medium);
  }
`;

export default Theme;
